import type { AdminGoodsInput } from '@lub0v/santa-utils';

export function parseGoodsClipboard(text: string): Partial<AdminGoodsInput> {
  if (text.length > 50000) throw new Error('Invalid product data');
  const data = JSON.parse(text);
  if (
    data?.format !== 'santa-yandex-product' ||
    data.version !== 1 ||
    !data.item ||
    typeof data.item !== 'object'
  )
    throw new Error('Invalid product data');
  const item = data.item;
  const string = (key: string, max: number) => {
    if (typeof item[key] !== 'string' || item[key].length > max)
      throw new Error('Invalid product data');
    return item[key].trim();
  };
  const link = new URL(string('link', 4096));
  if (
    link.protocol !== 'https:' ||
    link.hostname !== 'market.yandex.ru' ||
    link.username ||
    link.password ||
    link.port ||
    !/^\/(?:card\/|product--)[^/]+\/\d+\/?$/.test(link.pathname)
  )
    throw new Error('Invalid product link');
  const name = string('name', 256);
  if (!name) throw new Error('Missing product name');
  const image = string('image', 4096);
  if (image) {
    const url = new URL(image);
    if (url.protocol !== 'https:' || url.username || url.password) throw new Error('Invalid image');
  }
  const price = string('price', 20);
  if ((price && !/^\d{1,12}(\.\d{1,2})?$/.test(price)) || item.currency !== 'RUB')
    throw new Error('Invalid price');
  // Whitelist fields; never accept status, IDs or other administrative properties.
  return {
    name,
    image,
    price,
    currency: 'RUB',
    link: link.href,
    imageConfig: { x: 50, y: 50, scale: 1 },
  };
}
